import { render, staticRenderFns } from "./NsSepaForm.vue?vue&type=template&id=6d027f76&scoped=true&"
import script from "./NsSepaForm.vue?vue&type=script&lang=js&"
export * from "./NsSepaForm.vue?vue&type=script&lang=js&"
import style0 from "./NsSepaForm.vue?vue&type=style&index=0&id=6d027f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d027f76",
  null
  
)

export default component.exports